/** Web Audio incoming-chat ring (no asset file; works offline). */
export function playIncomingChatRing(): void {
  try {
    const AudioCtx = window.AudioContext || (window as any).webkitAudioContext;
    if (!AudioCtx) return;
    const ctx = new AudioCtx();
    const t0 = ctx.currentTime;

    const playTone = (freq: number, start: number, duration: number, volume = 0.18) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(freq, start);
      gain.gain.setValueAtTime(volume, start);
      gain.gain.exponentialRampToValueAtTime(0.001, start + duration);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(start);
      osc.stop(start + duration);
    };

    // Phone-style double ring (two pulses)
    playTone(880, t0, 0.22);
    playTone(660, t0 + 0.08, 0.28);
    playTone(880, t0 + 0.55, 0.22);
    playTone(660, t0 + 0.63, 0.28);

    window.setTimeout(() => {
      void ctx.close();
    }, 1200);
  } catch {
    /* autoplay blocked until user interacts with page */
  }
}
